export default "__VITE_ASSET__8290a285__"